// src/components/cards/GestaoOrderCard.jsx - VERSÃO 13.0 SUPREMA (SUPREME MODAL & COMPACT VIEW)
import React, { useState } from 'react';
import { 
    FiHash, FiFileText, FiUser, FiLayers, FiZap, 
    FiActivity, FiChevronDown, FiList, FiEye, FiClock, 
    FiTarget, FiCopy, FiKey, FiRefreshCw 
} from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-hot-toast';
import { OrderExecutionEngine } from '../../api/OrderExecutionEngine';

// 🛡️ IMPORTAÇÃO DO NOVO DOSSIÊ SUPREMO
import SupremeOrderModal from '../modals/SupremeOrderModal/index';
import { OrderHistoryModal, OrderLogModal, StatusUpdateModal } from '../modals/OrderIntelModals';

/**
 * 🗺️ MAPEAMENTO TÁTICO DE STATUS
 */
export const ORDER_STATUS_MAP = [
    { id: 'PENDENTE', label: 'Aguardando Triagem', color: 'bg-gray-500', cat: 'LINHAS_MOVEIS', sub: 'NOVOS' },
    { id: 'ATRIBUIDO', label: 'Atendimento Inicial 1', color: 'bg-blue-600', cat: 'LINHAS_MOVEIS', sub: 'CONSULTOR_DEVE_AGIR' },
    { id: 'Atendimento Inicial', label: 'Atendimento Inicial', color: 'bg-blue-600', cat: 'LINHAS_MOVEIS', sub: 'CONSULTOR_DEVE_AGIR' },
    { id: 'Inicio do Pedido', label: 'Início do Pedido', color: 'bg-blue-600', cat: 'LINHAS_MOVEIS', sub: 'CONSULTOR_DEVE_AGIR' },
    { id: 'Aguardando Documentos', label: 'Aguardando Documentos', color: 'bg-orange-500', cat: 'LINHAS_MOVEIS', sub: 'CLIENTE_DEVE_AGIR' },
    { id: 'Erro na Documentação', label: 'Erro na Documentação', color: 'bg-red-600', cat: 'LINHAS_MOVEIS', sub: 'CLIENTE_DEVE_AGIR' },
    { id: 'Reanalise Permitida', label: 'Reanálise Permitida', color: 'bg-pink-500', cat: 'LINHAS_MOVEIS', sub: 'CLIENTE_DEVE_AGIR' },
    { id: 'Emissão de Contrato', label: 'Emissão de Contrato', color: 'bg-indigo-500', cat: 'LINHAS_MOVEIS', sub: 'UNITY_DEVE_AGIR' },
    { id: 'Assinatura de Contrato', label: 'Assinatura de Contrato', color: 'bg-indigo-500', cat: 'LINHAS_MOVEIS', sub: 'CLIENTE_DEVE_AGIR' },
    { id: 'Qualidade 1 - Confirmação de Pedido', label: 'Qualidade 1 (MOS)', color: 'bg-purple-500', cat: 'LINHAS_MOVEIS', sub: 'UNITY_DEVE_AGIR' },
    { id: 'Qualidade 2 - Confirmação de Pedido', label: 'Qualidade 2 (TIM)', color: 'bg-purple-600', cat: 'LINHAS_MOVEIS', sub: 'TIM_DEVE_AGIR' },
    { id: 'Analise de Pedido', label: 'Análise de Pedido', color: 'bg-cyan-500', cat: 'LINHAS_MOVEIS', sub: 'TIM_DEVE_AGIR' },
    { id: 'Pedido Aprovado', label: 'Pedido Aprovado', color: 'bg-yellow-600', cat: 'LINHAS_MOVEIS', sub: 'TIM_DEVE_AGIR' },
    { id: 'Emissão de NF', label: 'Emissão de NF', color: 'bg-purple-500', cat: 'LINHAS_MOVEIS', sub: 'TIM_DEVE_AGIR' },
    { id: 'Aguardando Entrega', label: 'Aguardando Entrega', color: 'bg-sky-500', cat: 'LINHAS_MOVEIS', sub: 'LOGISTICA_ENTREGA' },
    { id: 'Falha na Entrega', label: 'Falha na Entrega', color: 'bg-red-500', cat: 'LINHAS_MOVEIS', sub: 'LOGISTICA_ENTREGA' },
    { id: 'Entrega Concluida', label: 'Entrega Concluída', color: 'bg-emerald-500', cat: 'LINHAS_MOVEIS', sub: 'LOGISTICA_ENTREGA' },
    { id: 'Aguardando Portabilidade', label: 'Portabilidade Pendente', color: 'bg-sky-500', cat: 'LINHAS_MOVEIS', sub: 'TIM_DEVE_AGIR' },
    { id: 'Erro de Portabilidade', label: 'Erro de Portabilidade', color: 'bg-red-500', cat: 'LINHAS_MOVEIS', sub: 'TIM_DEVE_AGIR' },
    { id: 'CONCLUIDO', label: 'Concluído / Ativo', color: 'bg-emerald-600', cat: 'LINHAS_MOVEIS', sub: 'APROVADO' },
    { id: 'CANCELADO', label: 'Cancelado', color: 'bg-red-800', cat: 'LINHAS_MOVEIS', sub: 'REPROVADO' },
    { id: 'Restrição TIM', label: 'Restrição TIM', color: 'bg-red-900', cat: 'LINHAS_MOVEIS', sub: 'CLIENTE_DEVE_AGIR' }
];

export default function GestaoOrderCard({ order, onStatusUpdate, readOnly = false }) {
    const [modalOpen, setModalOpen] = useState(null);
    const [pendingStatus, setPendingStatus] = useState(null);
    const [loadingToken, setLoadingToken] = useState(false);

    const orderNumber = order.numeroOrdem || '---';
    const fullProtocol = order.protocolo || 'NÃO GERADO';
    const accessKey = order.tokenAcesso || '------';
    const totalLines = order.itens?.reduce((acc, it) => acc + (Number(it.quantidade) || 0), 0) || 0;
    const totalMonthly = order.itens?.reduce((acc, it) => acc + ((Number(it.quantidade) || 0) * (Number(it.precoUnitario) || 0)), 0) || 0;
    const isVIP = order.isVIP || order.empresa?.isVIP || totalLines > 20;
    
    const currentStatusData = ORDER_STATUS_MAP.find(s => s.id === order.status) || { label: order.status, color: 'bg-gray-400' };

    const handleCopy = (text, label) => {
        navigator.clipboard.writeText(text);
        toast.success(`${label} COPIADO`);
    };

    const handleRegenerateToken = async (e) => {
        e.stopPropagation();
        if (!window.confirm("CONFIRMAR: Deseja invalidar a chave atual e gerar uma nova?")) return;
        setLoadingToken(true);
        try {
            const res = await OrderExecutionEngine.gerarNovoToken(order._id);
            if (res?.success) {
                toast.success("NOVA CHAVE SINCRONIZADA");
                window.location.reload();
            }
        } catch (err) { toast.error("FALHA NA REGENERAÇÃO"); } 
        finally { setLoadingToken(false); }
    };

    return (
        <>
            <motion.div layout initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="card-elite group border-2 border-[var(--border-color)] p-6">
                {isVIP && <div className="absolute top-0 right-0 w-24 h-24 -mr-12 -mt-12 bg-[var(--accent-color)] opacity-10 rotate-45 pointer-events-none" />}
                
                <div className="flex justify-between items-start mb-6">
                    <div className="space-y-4 w-full">
                        <div className="flex items-center gap-3">
                            <span className="text-[9px] font-black uppercase opacity-40 flex items-center gap-2 tracking-[0.15em]"><FiTarget className="text-accent" /> OPERAÇÃO TIM PJ</span>
                            {isVIP && <span className="text-[7px] font-black uppercase px-2 py-0.5 bg-accent text-white rounded-full animate-pulse">VIP</span>}
                        </div>
                        
                        <div className="space-y-1">
                            <h3 className="text-5xl font-black italic tracking-tighter text-[var(--text-primary)] leading-none">#{orderNumber}</h3>
                            
                            <div className="flex items-center gap-3 pt-1">
                                <div className="flex items-center gap-2 p-1.5 px-3 rounded-lg bg-white/5 border border-white/10 group/copy">
                                    <FiHash size={10} className="text-accent opacity-50" />
                                    <span className="text-[10px] font-black text-[var(--text-secondary)] tracking-widest">{fullProtocol}</span>
                                    <button onClick={() => handleCopy(fullProtocol, "PROTOCOLO")} className="ml-2 p-0.5 hover:bg-white/10 rounded transition-all">
                                        <FiCopy size={10} className="opacity-40 group-hover/copy:opacity-100" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* 🔑 TOKEN COMPACTO */}
                        <div className="flex items-center gap-4 p-4 px-6 rounded-2xl bg-black/30 border border-[var(--border-color)] w-fit group/token shadow-xl">
                            <FiKey size={16} className="text-accent" />
                            <div className="flex flex-col">
                                <span className="text-[7px] font-black uppercase opacity-30 leading-none mb-1.5 tracking-[0.2em]">Segurança</span>
                                <div className="flex items-center gap-4">
                                    <span className="text-lg font-black text-[var(--text-primary)] tracking-[0.4em] font-mono">{accessKey}</span>
                                    
                                    <div className="flex items-center gap-2 border-l border-white/10 pl-4">
                                        <button onClick={() => handleCopy(accessKey, "TOKEN")} className="p-2 bg-white/5 hover:bg-accent hover:text-white rounded-lg transition-all active:scale-90"><FiCopy size={12} /></button>
                                        <button onClick={handleRegenerateToken} className="p-2 bg-white/5 hover:bg-red-500 hover:text-white rounded-lg transition-all active:scale-90"><FiRefreshCw size={12} className={loadingToken ? 'animate-spin' : ''} /></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className={`px-4 py-1.5 rounded-xl text-[9px] font-black uppercase text-white shadow-xl border border-white/5 ${currentStatusData.color}`}>
                        {currentStatusData.label}
                    </div>
                </div>

                <div className="space-y-4 mb-6 py-6 border-y border-[var(--border-color)]">
                    <DataRow icon={FiFileText} label="CNPJ" value={order.empresa?.cnpj} />
                    <DataRow icon={FiLayers} label="Razão Social" value={order.empresa?.razaoSocial} bold />
                    <DataRow icon={FiUser} label="Solicitante" value={order.solicitante?.nome} />
                </div>

                <div className="p-6 rounded-[1.5rem] bg-[var(--bg-main)] border border-[var(--border-color)] shadow-inner mb-6">
                    <div className="flex justify-between items-center mb-4">
                        <div className="flex flex-col"><span className="text-[7px] font-black uppercase opacity-30 mb-1 tracking-widest">Linhas</span><span className="text-2xl font-black text-[var(--text-primary)]">{totalLines}</span></div>
                        <div className="h-10 w-[1px] bg-[var(--border-color)]"></div>
                        <div className="flex flex-col text-right"><span className="text-[7px] font-black uppercase opacity-30 mb-1 tracking-widest">Mensal</span><span className="text-xl font-black text-emerald-500">{totalMonthly.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span></div>
                    </div>
                    
                    {order.dataConclusao && (
                        <div className="border-t border-[var(--border-color)] pt-4 mt-2">
                            <div className="flex justify-between items-center">
                                <span className="text-[9px] font-black uppercase opacity-50 text-[var(--text-primary)]">{order.status === 'CANCELADO' ? 'Data Cancelamento:' : 'Data Faturamento:'}</span>
                                <span className={`text-xs font-black px-3 py-1 rounded-full ${order.status === 'CANCELADO' ? 'text-red-500 bg-red-500/10' : 'text-emerald-500 bg-emerald-500/10'}`}>
                                    {new Date(order.dataConclusao).toLocaleDateString('pt-BR')}
                                </span>
                            </div>
                        </div>
                    )}
                </div>

                <div className="grid grid-cols-3 gap-3 mb-6">
                    <ActionButton icon={FiClock} label="Histórico" onClick={() => setModalOpen('history')} />
                    <ActionButton icon={FiList} label="Logs" onClick={() => setModalOpen('log')} />
                    {/* 🕵️ BOTÃO ATUALIZADO: VER PEDIDO */}
                    <ActionButton icon={FiEye} label="Ver Pedido" onClick={() => setModalOpen('details')} />
                </div>

                {!readOnly && (
                    <div className="space-y-3">
                        <label className="text-[9px] font-black uppercase opacity-30 px-1 flex items-center gap-2"><FiActivity size={12} className="text-accent" /> Atualizar Radar</label>
                        <div className="relative">
                            <select 
                                value={order.status} 
                                onChange={(e) => { setPendingStatus(e.target.value); setModalOpen('status_comment'); }} 
                                className="w-full h-14 px-6 rounded-xl cursor-pointer font-black text-[11px] uppercase text-[var(--text-primary)] bg-[var(--bg-main)] border border-[var(--border-color)] appearance-none focus:border-accent transition-all"
                            >
                                {ORDER_STATUS_MAP.map(status => <option key={status.id} value={status.id} className="text-white bg-black">{status.label}</option>)}
                            </select>
                            <FiChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-accent pointer-events-none text-lg" />
                        </div>
                    </div>
                )}
            </motion.div>

            {/* MODALS PERSISTENTES */}
            <AnimatePresence>
                {modalOpen === 'history' && <OrderHistoryModal order={order} onClose={() => setModalOpen(null)} />}
                {modalOpen === 'log' && <OrderLogModal order={order} onClose={() => setModalOpen(null)} />}
                
                {/* 🛡️ RENDERIZAÇÃO DO DOSSIÊ SUPREMO */}
                {modalOpen === 'details' && <SupremeOrderModal order={order} onClose={() => setModalOpen(null)} />}
                
                {modalOpen === 'status_comment' && (
                    <StatusUpdateModal 
                        onClose={() => setModalOpen(null)} 
                        onConfirm={(c, ct, s, d) => onStatusUpdate(order._id, pendingStatus, c, ct, s, d)} 
                        newStatus={ORDER_STATUS_MAP.find(s => s.id === pendingStatus)?.label || pendingStatus} 
                        currentStatus={currentStatusData.label} 
                        defaultCat={ORDER_STATUS_MAP.find(s => s.id === pendingStatus)?.cat} 
                        defaultSub={ORDER_STATUS_MAP.find(s => s.id === pendingStatus)?.sub} 
                    />
                )}
            </AnimatePresence>
        </>
    );
}

// HELPERS DE INTERFACE COMPACTOS
const ActionButton = ({ icon: Icon, label, onClick }) => (
    <button onClick={onClick} className="flex flex-col items-center justify-center p-4 rounded-xl border border-[var(--border-color)] bg-[var(--bg-main)] hover:bg-[var(--accent-color)] hover:text-white transition-all group/btn shadow-md active:scale-90">
        <Icon size={18} className="mb-1.5 text-accent group-hover/btn:text-white" />
        <span className="text-[7px] font-black uppercase opacity-40 group-hover/btn:opacity-100">{label}</span>
    </button>
);

const DataRow = ({ icon: Icon, label, value, bold }) => (
    <div className="flex items-start gap-4 group/row">
        <div className="p-2 rounded-lg bg-[var(--bg-main)] border border-[var(--border-color)] text-accent opacity-60 group-hover/row:opacity-100 transition-all shadow-inner"><Icon size={14} /></div>
        <div className="flex flex-col min-w-0">
            <span className="text-[7px] font-black uppercase opacity-30 tracking-widest mb-0.5">{label}</span>
            <span className={`text-[11px] uppercase truncate ${bold ? 'font-black text-[var(--text-primary)]' : 'font-bold text-[var(--text-secondary)]'}`}>{value || '---'}</span>
        </div>
    </div>
);